import type { DecorationScreenSchema } from "./types";

const GRID_SIZES = ["big", "tall", "wide"] as const;

export const mainSchema = {
	banner: { css: [], visible: true, inserts: true, children: ["banner_media"] },
	banner_media: { css: [], visible: true },
	card: { css: GRID_SIZES, children: ["card_body"] },
	card_add: { css: [], children: ["card_counter", "card_add_button"] },
	card_add_button: { css: [], locked: true, children: ["card_add_icon"] },
	card_add_icon: { css: [] },
	card_body: { css: GRID_SIZES, children: ["card_inner"] },
	card_badges: { css: [] },
	card_calories: { css: GRID_SIZES, visible: false },
	card_carbs: { css: GRID_SIZES, visible: false },
	card_content: { css: GRID_SIZES, children: ["card_photo", "card_info"] },
	card_counter: { css: [], visible: true },
	card_description: { css: GRID_SIZES },
	card_fats: { css: GRID_SIZES, visible: false },
	card_image: { css: GRID_SIZES },
	card_info: { css: GRID_SIZES, children: ["card_title", "card_nutrition", "card_description", "card_badges", "card_price"] },
	card_inner: { css: GRID_SIZES, children: ["card_content"] },
	card_like: { css: [], visible: true },
	card_nutrition: { css: GRID_SIZES, children: ["nutrition_basis", "card_weight", "card_calories", "card_proteins", "card_fats", "card_carbs"] },
	card_photo: { css: GRID_SIZES, children: ["card_image", "card_rank", "card_badges", "card_like", "card_add"] },
	card_price: { css: GRID_SIZES, variant: { values: ["text", "split"], default: "text" }, children: ["card_price_prefix", "card_price_value"] },
	card_price_prefix: { css: [] },
	card_price_value: { css: [] },
	card_proteins: { css: GRID_SIZES, visible: false },
	card_rank: { css: [] },
	card_title: { css: GRID_SIZES },
	card_weight: { css: GRID_SIZES, visible: false },
	cart_button: { css: ["empty"] },
	cart_button_frame: { css: [] },
	cart_button_icon: { css: [], icon: true },
	cart_button_pill: { css: [] },
	cart_button_products: { css: [], visible: true, limit: { default: 3, min: 0, max: 50 } },
	cart_button_total: { css: [] },
	category_chips: { css: [], visible: true },
	category_title: { css: [] },
	combo_card_body: { css: [] },
	content: { css: [] },
	feed: { css: [] },
	filter_image_product: { css: [] },
	filter_image_product_img: { css: [] },
	filter_image_product_count: { css: [] },
	grid_column: { css: [] },
	header: { css: [] },
	header_back: { css: [], visible: false, icon: true },
	header_back_icon: { css: [] },
	header_cart: { css: ["filled"], visible: false, icon: true },
	header_cart_badge: { css: [] },
	header_cart_icon: { css: [] },
	header_favorites: { css: [], visible: true },
	header_greeting: { css: [], visible: true },
	header_icons: { css: [] },
	header_logo: { css: [], visible: false, icon: true },
	header_loyalty: { css: ["authorized"], visible: false, icon: true },
	header_loyalty_icon: { css: [] },
	lang_button: { css: ["open"] },
	lang_chevron: { visible: true },
	lang_icon: { visible: true },
	lang_label: { css: [] },
	lang_picker: { css: [] },
	lang_popup: { css: [] },
	liked_all_title: { css: [] },
	liked_mine: { css: [], children: ["liked_mine_title", "liked_mine_grid"] },
	liked_mine_grid: { css: [], children: ["card"] },
	liked_mine_title: { css: [] },
	loyalty_scan_button: { css: [], visible: true },
	nutrition_basis: { css: [], visible: false },
	nutrition_basis_option: { css: ["active"] },
	page: { css: [] },
	rail: { css: [] },
	rail_fade_bottom: { css: [], visible: true },
	rail_fade_top: { css: ["scrolled"], visible: true },
	rail_item: { css: ["active", "last"] },
	rail_item_image: { css: [] },
	rail_item_label: { css: ["active"] },
	rail_list: { css: [] },
	rail_panel: { css: [] },
	rail_search_button: { css: [], visible: true },
	rail_viewport: { css: [] },
	recommendation: { css: [] },
	section: { css: ["last"], children: ["section_header", "liked_mine", "liked_all_title", "category_title", "section_grid"] },
	section_breadcrumbs: { css: [] },
	section_grid: { css: [], layouts: { sizes: GRID_SIZES }, children: ["card"] },
	section_header: { css: [], children: ["section_title", "section_tags", "section_breadcrumbs"] },
	section_tags: { css: [] },
	section_title: { css: [] },
} as const satisfies DecorationScreenSchema;
